/* 
 *  Copyright © Ludvik Michalek, Bigfoot Interactive
 *  http://www.bigfoot.cz/
 */

var Config = {
	breakpoints: {
		desktop: 1360 - 1,
		tablet: 1000 - 1,
		mobile: 768 - 1,
		mobileSmall: 480 - 1,
		mobileTiny: 340 - 1
	}
};


function isInViewport(node) {
	var rect = node.getBoundingClientRect();
	return (
		(rect.height > 0 || rect.width > 0) &&
		rect.bottom >= 0 &&
		rect.right >= 0 &&
		rect.top <= (window.innerHeight || document.documentElement.clientHeight) &&
		rect.left <= (window.innerWidth || document.documentElement.clientWidth)
	);
}


function isTouchDevice(){
	var device = $('html').data('device');
	if(device === 'mobile' || device === 'tablet') {
		return true;
	}
	return false;
}


$(document).ready(function () {
	var controllerAction = $('html').data('controllerAction');
	var body = $('body');
	var page;
	
	
	/*
	 * Global elements
	 */
	var mainMenu = new MainMenu($('header'));
	var langMenu = new LangMenu($('#lang-menu'));
	

	/*
	 * Template-specific init
	 */
	switch(controllerAction){
		case 'site/index':
			page = new HomepageController(body);
			break;
			
		case 'site/reference':
			switch(body.data('referenceAlias')){
				case 'abriko-jams':
					page = new ReferenceAbrikoJamsController(body);
					break;
				case 'frueva-jams':
					page = new ReferenceFruevaJamsController(body);
					break;
				case 'ccha-tea':
					page = new ReferenceCcchaTeaController(body);
					break;
				case 'kava-standard':
					page = new ReferenceKavaStandardController(body);
					break;
				case 'nicolaus-vodka':
					page = new ReferenceNicolausVodkaController(body);
					break;
				case 'orion-banany':
					page = new ReferenceOrionBananyController(body);
					break;
				case 'orion-kastany':
					page = new ReferenceOrionKastanyController(body);
					break;
				case 'zlata-studna':
					page = new ReferenceZlataStudnaController(body);
					break;
				case 'zlata-studna-water':
					page = new ReferenceZlataStudnaWaterController(body);
					break;
				case 'koli-syrups':
					page = new ReferenceKoliSyrupsController(body);
					break;
				case 'infinit-nutrition':
					page = new ReferenceInfinitNutritionController(body);
					break;
			}
			break;
			
		default:
			break;
	}
	
	
	/*
	 * Global init
	 */
	NavigationUtils.initScrollToElementLinks();
	NavigationUtils.initScrollToElementOnLoad('-scroll');
	
	Gridle.on('update', function (updatedStates, activeStates, inactiveStates) {
		if (Gridle.isActive('mobile')) {
			// Show swipe hints on mobile
			$('section[data-swipe-hint="true"]').each(function() {
				var target = $(this);
				var hint = new SwipeHint(target);
			});
			
			// init scrollable DIVs
			$('.image-scroll-mobile').each(function() {
				var container = new ScrollContainer($(this));
			});
		}
	});

});
